import React from 'react'
import PropTypes from 'prop-types';
import Page from 'components/Page';
import Workspace from 'components/Workspace';
import Tr from 'translations/Translations';
import HomeRoute from './HomeRoute';
import {makeStyles} from "@material-ui/core/styles";

const useStyle = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    }
}))

function MyProcedureHome() {

    const classes = useStyle();

    return (
        <div className={classes.root}>
            <Page
                floatingWorkspace
            >
                <Workspace
                    title={Tr('my_procedure')}
                >
                    {/*<TabsPage tabs={tabs}>*/}
                    <HomeRoute/>
                    {/*</TabsPage>*/}
                </Workspace>
            </Page>
        </div>
    )
}

MyProcedureHome.propTypes = {
    classes: PropTypes.any,
}

MyProcedureHome.defaultProps = {}

export default MyProcedureHome;
